import {favoriteStoreURL, pathname} from "../../../Assets/javascripts/common/others/Configuration";
import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import SharedDispatcher from "../../../Assets/javascripts/common/others/SharedDispatcher";
import mapService from "../../../Assets/javascripts/common/services/mapService";

export default Backbone.View.extend({


    /**
     * Constructor
     */
    initialize: function() {

      // It allows to know if left menu contains all stores list or only close stores based on research.
      this.closeStoresListIsVisible = false;

      this.$address = $('.js-StoreFinder-addressInput');
      this.$btClear = $('.js-StoreFinder-btClear');
      this.$mapInfos = $('.js-StoreFinder-mapInfos');

      this.storeMarkers = [];
      this.storeCards = [];
      this.storeDistances = [];

      this.defaultZoom = 6;

      this.mapElement = $('.js-StoreFinder-map')[0];
      this.storeFinderElement = document.getElementsByClassName('js-store-finder')[0];

      this.mapLatitude = this.mapElement.getAttribute('data-latitude');
      this.mapLongitude = this.mapElement.getAttribute('data-longitude');

      this.mapZoom = Number(this.mapElement.getAttribute('data-zoom')) || this.defaultZoom;

      this.sideList = '.js-StoreFinder-shopList ul.opened';
      this.selectedOrganisation = 0; //fnac as default

      // Render when map load ready
      mapService.on('load:desktop', () => {
        this.render();
      });

      // Load map service
      mapService.load('desktop');

    },

    /**
     * Render the view
     */
    render: function() {

      this.mapCenterPosition = new Microsoft.Maps.Location(this.mapLatitude, this.mapLongitude);
      this.map = mapService.create(this.mapElement);

      this.map.setView({
        zoom: this.mapZoom,
        center: this.mapCenterPosition
      });

      this.generateStoreCards();
      this.displayStoresOnMap();

      var address = this.$address.val();
      if (address !== '') {
        this.launchSearch(address);
        this.$btClear.removeClass('hide');
      } else {
        this.showShopsCount(fnacStoreData.Store.length);
      }

    },

    /**
     * Sets zoom and the center of this map with default parameters
     */
    setMapDefaultParameters: function() {
      if (this.map) {
        this.map.setView({
          zoom: this.defaultZoom,
          center: this.mapCenter
        });
      }
    },

    degreeToRad: function(degree) {
      return degree * Math.PI / 180;
    },

    /**
     * Recalculate all distances of store which are located less than 150 kilometers
     * @param {object} initialPosition
     * @returns {array} Array of store objects sort by distances
     */
    recalculateDistance: function(initialPosition) {

      this.storeDistances = [];

      fnacStoreData.Store.forEach(function(store) {

        var storePosition = this.strToPoint(store.coord);

        var nbKilometersFromInitialPositionToStore = this.distHaversine(initialPosition, storePosition);
        var nbKilometersRounded = Math.round(nbKilometersFromInitialPositionToStore * 1000) / 1000;

        this.storeDistances.push({ store: store, value: nbKilometersRounded });

      }, this);

      var filteredDistances = _.filter(this.storeDistances, function(storeDistance) {
        return storeDistance.value < 150;
      });

      return _.sortBy(filteredDistances, function(filteredDistance) {
        return filteredDistance.value;
      });

    },

    /**
     * Display the close stores menu with calculated distances.
     * @param {array} distanceItems Calculated distances (sorted and filtered)
     */
    displayCloseStores: function(distanceItems) {

      this.closeStoresListIsVisible = true;

      var $allStoreElements = $('.js-StoreFinder-allStores');
      var $allCloseStoreElements = $('.js-StoreFinder-closeStores');

      $allCloseStoreElements.html('');

      distanceItems.forEach(function(distanceItem) {
        var $storeMenuElement = $(this.sideList + " li[data-eag-id=" + distanceItem.store.EAGId + "]");
        if ($storeMenuElement) {
          $storeMenuElement.removeClass('hide');
          var $htmlContent = $($storeMenuElement.closest("li").prop("outerHTML"));
          var $shopDistanceElement = $htmlContent.find(".js-StoreFinder-shopDistance");
          $shopDistanceElement.text(this.kmToString(distanceItem.value));
          $allCloseStoreElements.append($htmlContent);
        }
      }, this);

      $allStoreElements.removeClass('opened').addClass('hide');
      $allCloseStoreElements.removeClass('hide').addClass('opened');

    },

    /**
     * ToString implementation for number of kilometers
     * @param {int} km Number of kilometers
     * @returns {string}
     */
    kmToString: function(km) {

      if (km < 1) {
        return (1000 - (km * 1000)).toFixed(2).toString() + ' m';
      } else {
        return km.toFixed(2).toString().replace('.', ',') + ' km';
      }

    },

    /**
     * Launch search: get the correct position of this research (latitude + longitude) and refresh map contents.
     * @param {string} search
     */
    launchSearch: function(search) {

      var self = this;

      if (search == null || search === '') {
        return;
      }

      if (this.selectStore) {
        this.clearSelection();
      }

      mapService.geocode(search, {}, 'nav_store_locator').then(function(coordinates) {

        var centerMap = new Microsoft.Maps.Location(coordinates.Latitude, coordinates.Longitude);

        self.map.setView({
          center: centerMap,
          zoom: 12
        });
        //self.refreshCenterPosition();

        var sortedAndFilteredDistances = self.recalculateDistance(centerMap);
        self.displayCloseStores(sortedAndFilteredDistances);
        self.showShopsCount(sortedAndFilteredDistances.length);
      });

    },

    /**
     * Add marker with the position of user
     * @param {object} position
     */
    addSearchPositionOnMap: function(position) {

      if (this.searchPositionMarker) {
        this.map.entities.remove(this.searchPositionMarker);
        this.searchPositionMarker = null;
      }
      this.searchPositionMarker = this.createMarker(position);
    },

    /**
     * Refresh and display the count of stores
     * @param {int} count number of filtered stores
     */
    showShopsCount: function(count) {
      $('.js-StoreFinder-shopCount > .value').html(count);
      $('.StoreFinder-shopCount > .plural').css('display', count > 1 ? 'inline' : 'none');
      $('.StoreFinder-shopCount > .singular').css('display', count < 2 ? 'inline' : 'none');
    },

    /**
     * ToString for position object
     * @param {object} point
     */
    strToPoint: function(point) {
      if (point) {
        var separatorPosition = point.indexOf(",");
        var pointLat = point.substring(1, separatorPosition);
        var pointLng = point.substring(separatorPosition + 1, point.length - 1);
        return new Microsoft.Maps.Location(pointLat, pointLng);
      }
      return null;
    },

    /**
     * Create markers for each stores
     */
    displayStoresOnMap: function() {

      var self = this;

      fnacStoreData.Store.forEach(function(store) {
        var strPoint = store.coord;
        if (strPoint) {
          var storePosition = this.strToPoint(strPoint);



          var magasin = 'fnac'

          var storeName = store.Name.toLowerCase()
          if (storeName.includes('darty') && !storeName.includes('fnac')) {
            magasin = 'darty'
          }
          var createdStoreMarker = this.createMarker(storePosition, magasin, store.EAGId);

          Microsoft.Maps.Events.addHandler(createdStoreMarker, 'click', function (pushpin) {
            self.selectStore(Number(store.EAGId), pushpin.target.entity.id);
          });

          this.storeMarkers.push(createdStoreMarker);
        }

      }, this);
    },

    /**
     * Display html element which contains card store
     * @param {int} storeId  Store identifier
     */
    showCardInfo: function(storeId) {
      var storeCard = _.find(this.storeCards, function(store) {
        return Number(store.id) === storeId;
      });
      if (storeCard) {
        $(".StoreFinder-mapInfos").removeClass('zone').addClass('filled').html(storeCard.html);
      }
    },

    displayStoreMarkerAndCardOnMap: function(organization, point, storeId) {
      if (point !== '') {
        var objLat = this.strToPoint(point);

        this.map.setView({
          zoom: 15,
        });

        this.mapCenter = objLat;

        this.map.setView({
          zoom: 15,
        });

        this.mapCenter = objLat;

        if (storeId) {
          this.showCardInfo(storeId);
        }

        this.refreshCenterPosition();

        if (this.selectedMarker) {
          this.selectedMarker.setOptions({
            icon: mapService.icon({ type: 'shop', organization: this.selectedOrganisation })
          });
        }
        // select mew marker
        this.selectedMarker = _.find(this.storeMarkers, function(store) {
          return (store.eagId == storeId) ? store : null;
        });

        this.selectedOrganisation = organization;

        // use selected icon for new marker
        if (this.selectedMarker) {
          this.selectedMarker.setOptions({
            icon: mapService.icon({ type: 'shop', organization: this.selectedOrganisation, selected: true })
          });
        }
      }
    },

    /**
     * Ajust scroll of side menu for visualize your selection
     * @param {object} $selectedStoreMenuElement Jquery object (li html element) which represents the selected item menu
     */
    setSideStoreScrollPositionToViewThisItem: function($selectedStoreMenuElement) {

      var $menuBlock = $selectedStoreMenuElement.parents('.js-StoreFinder-shopList');

      var selectedStoreMenuPosition = $selectedStoreMenuElement.position(); // position du li relative au parent
      var selectedStoreMenuHeight = $selectedStoreMenuElement.outerHeight(); // Hauteur du premier élément

      if (selectedStoreMenuPosition.top + selectedStoreMenuHeight > $menuBlock.height()) {
        $menuBlock.scrollTop($menuBlock.scrollTop() + selectedStoreMenuPosition.top + selectedStoreMenuHeight - selectedStoreMenuHeight);
      } else if (selectedStoreMenuPosition.top < 0) {
        $menuBlock.scrollTop($menuBlock.scrollTop() + selectedStoreMenuPosition.top);
      }

    },

    /**
     * Select a store on map
     * @param {int} storeId Store identifier
     */
    selectStore: function(storeId) {
      var $sideStoreItemSelected;
      if (this.closeStoresListIsVisible === true) {

        $sideStoreItemSelected = this.$('.js-StoreFinder-closeStores li[data-eag-id="' + storeId + '"]');
        if (!$sideStoreItemSelected.length) {
          this.$address.val('');
          this.clearSelection();
          this.selectStore(storeId);
          this.showShopsCount($(".js-StoreFinder-allStores li:not(.hide)").length);
          return;
        }

      } else {
        $sideStoreItemSelected = this.$('.js-StoreFinder-allStores li[data-eag-id="' + storeId + '"]');
      }

      // @todo avoid using jquery when possible, use attr instead
      var point = $sideStoreItemSelected.data('point');
      var organization = $sideStoreItemSelected.data('organization');
      var index = $(event.currentTarget).index() + 1;
      // @todo use false/truthy conditions
      if (point == null || index == null) {
        return;
      }

      var selectedClassName = "shop--selected";
      $("." + selectedClassName).removeClass(selectedClassName);
      $sideStoreItemSelected.addClass(selectedClassName);

      this.displayStoreMarkerAndCardOnMap(organization, point, storeId);
      this.setSideStoreScrollPositionToViewThisItem($sideStoreItemSelected);
    },

    /**
     * Cancel the search, clear selection and empty research fields
     */
    clearSearch: function() {
      this.$address.val('');
      this.clearSelection();
      this.mapCenter = this.mapCenterPosition;
      this.setMapDefaultParameters();
      this.$btClear.addClass('hide');
    },

    clearSelection: function() {

      $('.js-StoreFinder-shopList').scrollTop(0);

      $(".shop--selected").removeClass('shop--selected');
      $('.js-StoreFinder-allStores').removeClass('hide').addClass('opened');
      $('.js-StoreFinder-closeStores').addClass('hide').removeClass('opened');
      $('.js-StoreFinder-shopList > li.selected').removeClass('selected');
      $(".js-StoreFinder-mapInfos").addClass('zone').removeClass('filled').html('');

      this.$el.find('.js-StoreFinder-stores').removeClass('hide');

      if (this.searchPositionMarker) {
        this.map.entities.remove(this.searchPositionMarker);
        this.searchPositionMarker = null;
      }

      if (this.selectedMarker) {
        this.selectedMarker.setOptions({
          icon: mapService.icons[this.selectedOrganisation]
        });

        this.selectedMarker = null;
      }

      this.closeStoresListIsVisible = false;

    },

    /**
     * Perform processing for address changes
     * @param {string} searchContent address searched
     * @param {string} key It represents the unmodified value of the pressed key.
     */
    manageKeyUp: function(searchContent, key) {

      if (searchContent === '') {

        this.clearSelection();
        this.mapCenter = this.mapCenterPosition;
        this.setMapDefaultParameters();
        this.$btClear.addClass('hide');

      } else if (this.$btClear.hasClass('hide')) {
        this.$btClear.removeClass('hide');
      }

      switch (key) {
        // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
        case "Enter":
          this.launchSearch(searchContent);
          break;

        default:
          if (this.closeStoresListIsVisible === false) {
            this.filterSideStoreList(searchContent);
          }
          break;
      }

      this.showShopsCount($(".js-StoreFinder-allStores li:not(.hide)").length);

    },

    /**
     * Filter the left side menu with address
     * @param {string} searchContent address searched
     */
    filterSideStoreList: function(searchContent) {

      var $selectedStoreElement = $(this.sideList + ' li.selected');
      $(this.sideList + ' li').each(function() {

        var $storeElement = $(this);

        var value = $storeElement.text().toLowerCase();
        var zipcode = $storeElement.data('zipcode').toString();

        if (value.indexOf(searchContent) < 0 && zipcode.indexOf(searchContent) !== 0) {
          $storeElement.addClass('hide');
        } else {
          $storeElement.removeClass('hide');
        }
      });

      if ($selectedStoreElement.hasClass('hide')) {
        $selectedStoreElement.removeClass('selected');
      }

    },

    /**
     * Create marker on map
     * @param {object} position It represents latitude and longitude
     * @param {string} icon Url for icon image
     * @param {string} eagId Store reference
     * @returns {object}  Microsoft maps pushpin object
     */
    createMarker: function(position, magasin, eagId) {
      var pushpin = new Microsoft.Maps.Pushpin(position, {
        icon: mapService.icons[magasin],
        anchor: new Microsoft.Maps.Point(13, 40)
      });

      pushpin.eagId = eagId;
      this.map.entities.push(pushpin);
      return pushpin;
    },

    /**
     * Generate html code for store card (main timetable)
     * @param {object} store
     * @returns {string}  Html code of main timetable
     */
    generateHtmlTimetables: function(store) {
      var htmlResult = '';
      if (store.Timetables != null) {
        var hasStandardOpeningsTitle = false;
        for (var x = 0; x < store.Timetables.length; x++) {
          var timeTable = store.Timetables[x];
          if (!hasStandardOpeningsTitle) {
            htmlResult = htmlResult.concat('<div class="store_standard_openings">' + this.$mapInfos.data('label-open-std') + '</div>');
            hasStandardOpeningsTitle = true;
          }
          htmlResult = htmlResult.concat('<div><span class="store_dayofweek">' + timeTable.DayOfWeek +
            '</span><span class="store_openingtime">' + timeTable.OpeningPeriods + '</span></div>');
        }
      }
      return htmlResult;
    },

    /**
     * Generate html code for store card (exceptionnal timetable)
     * @param {object} store
     * @returns {string}  Html code of exceptionnal timetable
     */
    generateHtmlExceptionnalTimetables: function(store) {
      var htmlResult = '';
      if (store.ExceptionnalTimetables != null) {

        var hasSpecialClosingsTitle = false;
        var hasSpecialOpeningsTitle = false;

        for (var y = 0; y < store.ExceptionnalTimetables.length; y++) {

          var exceptionnalTimeTable = store.ExceptionnalTimetables[y];

          if (exceptionnalTimeTable.IsOpened) {
            if (!hasSpecialOpeningsTitle) {
              htmlResult = htmlResult.concat('<div class="store_special_openings">' + this.$mapInfos.data('label-open-spe') + '</div>');
              hasSpecialOpeningsTitle = true;
            }
          } else if (!hasSpecialClosingsTitle) {
            htmlResult = htmlResult.concat('<div class="store_special_closings">' + this.$mapInfos.data('label-close-spe') + '</div>');
            hasSpecialClosingsTitle = true;
          }

          htmlResult = htmlResult.concat('<div class="store_special_time">' + exceptionnalTimeTable.Day + (exceptionnalTimeTable.Openings != null ? '<br>' + exceptionnalTimeTable.Openings : '')
            + (exceptionnalTimeTable.Comments != null ? '<br>' + exceptionnalTimeTable.Comments : '') + '</div>');
        }
      }
      return htmlResult;
    },

    /**
     * Generate html code for store card and push this html in storeCards array.
     */
    generateStoreCards:  function () {

      fnacStoreData.Store.forEach(function (store) {

        var storeName = store.Name;
        if (!storeName.toLowerCase().includes('fnac') && !storeName.toLowerCase().includes('darty')) {
          storeName = 'FNAC ' + store.Name;
        }
        var generatedHtmlCard = '<i class="close icon icon_i_037_cross_03"></i>' +
          '<div class="zone map_card arrow_box">' +
          '<div class="store_name">' +
          '<strong>' + storeName + '</strong>' +
          '</div>';

        if (store.Url !== '') {
          var labelAllInfos = this.$mapInfos.data('label-all-infos');
          generatedHtmlCard = generatedHtmlCard.concat('<div class="card_button"><a href="' + store.Url + '" class="ff-button ff-button--orange ff-button--block">' + labelAllInfos + '</a></div>');
        }

        generatedHtmlCard = generatedHtmlCard.concat('<div class="store_infos">' +
          '<div class="store_address">' +
          '<div>' + store.AddressLine + '</div>' +
          '<div>' + store.ZipCode + ' ' + store.CityName + '</div></div>' +
          '<div class="store_coord">');

        if (store.Phone != null && store.Phone !== "") {
          generatedHtmlCard = generatedHtmlCard.concat('<div>' + store.Phone + '</div>');
        }
        generatedHtmlCard = generatedHtmlCard.concat('</div>');

        generatedHtmlCard = generatedHtmlCard.concat(this.generateHtmlTimetables(store));
        generatedHtmlCard = generatedHtmlCard.concat(this.generateHtmlExceptionnalTimetables(store));

        this.storeCards.push({
          id: store.EAGId,
          html: generatedHtmlCard
        });

      }, this);

    },

    /**
     * Calculate the shortest distance between two positions
     * https://en.wikipedia.org/wiki/Haversine_formula
     * @param {object} position1
     * @param {object} position2
     * @returns {float} Distance between two positions
     */
    distHaversine: function(position1, position2) {
      var radiusOfTheEarth = 6371;
      var latitudeRadians = this.degreeToRad(position2.latitude - position1.latitude);
      var longitudeRadians = this.degreeToRad(position2.longitude - position1.longitude);
      var calculatedValue = Math.sin(latitudeRadians / 2) * Math.sin(latitudeRadians / 2) + Math.cos(this.degreeToRad(position1.latitude))
        * Math.cos(this.degreeToRad(position2.latitude)) * Math.sin(longitudeRadians / 2) * Math.sin(longitudeRadians / 2);
      var radiusCoefficient = 2 * Math.atan2(Math.sqrt(calculatedValue), Math.sqrt(1 - calculatedValue));
      var distance = radiusOfTheEarth * radiusCoefficient;
      return distance;
    },

    /**
    * Sets the center of this map
    * @param {object} lat Latitude ranges between -90 and 90 degrees
    * @param {object} lng Longitude ranges between -180 and 180 degrees
     */
    setCenterWithCoordinates: function(lat, lng) {
      this.mapCenter = new Microsoft.Maps.Location(lat, lng);
      this.refreshCenterPosition();
    },

    refreshCenterPosition: function() {
      if (this.map && this.mapCenter) {
        this.map.setView({
          center: this.mapCenter
        });
      }
    },

    updateUserStore: function(storeId) {

      var requestObj = { storeId: storeId };

      return $.ajax({
        url: favoriteStoreURL,
        type: 'POST',
        dataType: 'json',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        data: requestObj,
        error: function(err) {
          SharedDispatcher.trigger('flashmessage:show');
        }
      });

    },

    //
    // EVENTS
    //
    events: {
      'click .js-StoreFinder-chooseStoreButton': 'onChooseFavoriteStoreClicked',
      'click .js-StoreFinder-shopList li': 'onSearchPanelClicked',
      'click .js-StoreFinder-mapInfos .close': 'onCloseStoreCardButtonClicked',
      'keyup .js-StoreFinder-addressInput': 'onAddressKeyUp',
      'click .js-StoreFinder-searchSubmit': 'onSearchButtonClicked',
      'click .js-StoreFinder-btClear': 'onClearButtonClicked'
    },

    onChooseFavoriteStoreClicked: function(e) {

      var self = this;
      e.preventDefault();
      if (e.currentTarget) {
        var $chooseFavoriteStoreButton = $(e.currentTarget);

        if ($chooseFavoriteStoreButton.length) {
          var $storeMenuItems = $chooseFavoriteStoreButton.parents('li');
          if ($storeMenuItems.length) {
            var $storeMenuItem = $($storeMenuItems[0]);
            var storeId = $storeMenuItem.data('eag-id');

            this.updateUserStore(storeId).done(function(result) {

              var $previousFavoriteStoreItem = self.$el.find('.icon_i_119_Heart_Full');
              if ($previousFavoriteStoreItem.length) {
                $previousFavoriteStoreItem.removeClass('icon_i_119_Heart_Full').addClass('icon_i_110_Heart_Empty');
              }

              var $favoriteStoreIcon = $chooseFavoriteStoreButton.find('.icon_i_110_Heart_Empty');
              if ($favoriteStoreIcon.length) {
                $favoriteStoreIcon.removeClass('icon_i_110_Heart_Empty');
                $favoriteStoreIcon.addClass('icon_i_119_Heart_Full');
              }

              var $headerTabStore = $('.js-HeaderTabStore');
              if ($headerTabStore.length) {
                $headerTabStore.html(result.headerHtml);
              }

            });

          }
        }
      }
    },

    onSearchPanelClicked: function(event) {
      var index = $(event.currentTarget).index() + 1;
      if (event != null) {
        var storeId = Number(event.currentTarget.getAttribute('data-eag-id'));
        if (storeId) {
          this.selectStore(storeId);
        }
      }
    },

    onCloseStoreCardButtonClicked: function(event) {
      if (event) {
        event.preventDefault();
        this.$mapInfos.removeClass('filled').addClass('zone');
      }
    },

    onAddressKeyUp: function(event) {
      var searchContent = $(event.currentTarget).val();
      if (searchContent) {
        searchContent = $.trim(searchContent.toLowerCase());
      }
      this.manageKeyUp(searchContent, event.key);
    },

    onSearchButtonClicked: function(event) {
      if (event) {
        event.preventDefault();
        this.launchSearch(this.$address.val());
      }
    },

    onClearButtonClicked: function(event) {
      if (event != null) {
        event.preventDefault();
        this.clearSearch();
        this.showShopsCount(fnacStoreData.Store.length);
      }
    }
  });
